// extracted by mini-css-extract-plugin
export var icon = "style_icon__RTfUx";
export var iconWithBg = "style_iconWithBg__qhdmP";